import { createActions, createReducer } from 'reduxsauce'
import moment from 'moment'
import ReceitaDiariaService from '../../servicos/ReceitaDiariaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaReceitaDiariaInicio: [],
    buscaReceitaDiariaSucesso: ['receitaDiaria'],
    buscaReceitaDiariaErro: ['erro'],
    setSelecionadoReceitaDiariaSucesso: ['selecionado'],
    setReceitaDiariaEstadoDT: ['estado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
    estadoDT: {},
}

// Ação para busca completa
Creators.buscaReceitaDiaria = filtro => {
    return dispatch => {
        dispatch(Creators.buscaReceitaDiariaInicio())
        let serv = new ReceitaDiariaService()
        let data = {
            dataInicial: filtro.dataInicial ? moment(filtro.dataInicial).utc().format() : null,
            dataFinal: filtro.dataFinal ? moment(filtro.dataFinal).utc().format() : null,
            administracao: filtro.administracao ? filtro.administracao.map(e => e.value).join() : null,
            codigoRecurso: filtro.recurso ? filtro.recurso.map(e => e.value).join() : null,
            codigoDestinacao: filtro.destinacao ? filtro.destinacao.map(e => e.value).join() : null,
            grau: filtro.grau ? filtro.grau.value : null,
            codigoReceita: filtro.codigoReceita ? filtro.codigoReceita : null,
        }

        return serv
            .consultar(data)
            .then(response => dispatch(Creators.buscaReceitaDiariaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaReceitaDiariaErro(error)))
    }
}

const buscaReceitaDiariaInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaReceitaDiariaErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaReceitaDiariaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.receitaDiaria.resultado, dataSincronizacaoDados: action.receitaDiaria.dataAtualizacaoDados, carregando: false }
}

const setSelecionadoReceitaDiariaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

const setReceitaDiariaEstadoDT = (state = INITIAL_STATE, action) => {
    return { ...state, estadoDT: action.estado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_RECEITA_DIARIA_INICIO]: buscaReceitaDiariaInicio,
    [Types.BUSCA_RECEITA_DIARIA_ERRO]: buscaReceitaDiariaErro,
    [Types.BUSCA_RECEITA_DIARIA_SUCESSO]: buscaReceitaDiariaSucesso,
    [Types.SET_SELECIONADO_RECEITA_DIARIA_SUCESSO]: setSelecionadoReceitaDiariaSucesso,
    [Types.SET_RECEITA_DIARIA_ESTADO_DT]: setReceitaDiariaEstadoDT,
})
